// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductGrid_root___oORA"};